// extracted by mini-css-extract-plugin
export default {"bigTicker":"Ticker_bigTicker__8mw-x","smallTicker":"Ticker_smallTicker__vTe6w"};